<template>
<!-- :style="{paddingLeft: info.picture ? '185px' : '20px'}" -->
<div class="cardContainer clearfix" :class="info.isOnline=='离线'?'active':info.isAlarm=='报警中'?'active1':'active2'">
  <!-- <div class="img imgBox" v-if="info.picture"><img :src="info.picture" alt=""></div> -->
  <div class="text">
    <div class="titleMess" :class="setSSid(info.ssid)==0?'act0':setSSid(info.ssid)==1?'act1':setSSid(info.ssid)==2?'act2':setSSid(info.ssid)==3?'act3':setSSid(info.ssid)==4?'act4':''">
      <h4 :title="info.name" @click="$emit('clickEven',info)">{{info.name}}</h4>
      <div class="ssidMess">
        <div class="mess0 common"></div>
        <div class="mess1 common"></div>
        <div class="mess2 common"></div>
        <div class="mess3 common"></div>
        <div class="mess4 common"></div>
      </div>
    </div>
    <div class="infoList">
      <dl>
        <dd v-for="(field,index) in showFields" :key="index">
          <span class="mess messOnline" :class="[info[field.field] == '在线' ? 'normal' : 'abnormal']" v-if="field.field === 'isOnline'">
            <i></i><span>{{info[field.field]}}</span>
          </span>
          <span class="mess messAlarm" :class="[info[field.field] == '正常' ? 'normal' : 'abnormal']" v-else-if="field.field === 'isAlarm'&&info.isOnline == '在线'">
            <i></i><span>{{info[field.field]}}</span>
          </span>
          <span :title="getLocation(info.installGps)+info[field.field]" class="messOther" v-else-if="field.field === 'installLocation'">
            <span>安装位置：</span><span>{{getLocation(info.installGps)+info[field.field]}}</span>
          </span>
          <span class="messOther" :title="info[field.field]" v-else>
            <span>{{field.name ? (field.name + '：') : ''}}{{info[field.field]?info[field.field]:'无'}}</span>
          </span>
        </dd>
      </dl>
    </div>
  </div>
  <div class="handleBtns">
    <div class="gotoChild" :class="info.isOnline=='离线'?'activeGray':info.isAlarm=='报警中'?'activeRed':'activeGreen'">
      <div class="tip"><b>{{info.typeId == 337 ? '传感器' : '子设备'}}：</b><span>{{info.sensorTotalNumber?info.sensorTotalNumber:0}}</span></div>
      <div class="imgBox" @click="$emit('clickEvenChild',info)" v-if="info.isOnline=='离线'"><img src="../../../assets/img/gateway/grayIn.png" alt=""></div>
      <div class="imgBox" @click="$emit('clickEvenChild',info)" v-else-if="info.isAlarm=='正常'"><img src="../../../assets/img/gateway/greenIn.png" alt=""></div>
      <div class="imgBox" @click="$emit('clickEvenChild',info)" v-else><img src="../../../assets/img/gateway/redIn.png" alt=""></div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'Card',
  props: {
    who: {
      type: String,
      default: ''
    },
    showFields: {
      type: Array,
      default: () => {
        return []
      }
    },
    handles: {
      type: Array,
      default: () => {
        return ['details', 'edit', 'del']
      }
    },
    info: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data(){
    return{
      addressNew:''
    }
  },
  created() {
    // console.log(this.who)
    // console.log(this.info);
  },
  methods: {
    setSSid (val) {
      if (0<val&&val<8) {
        return 0
      } else if (7<val&&val<18){
        return 1
      } else if(17<val&&val<23){
        return 2
      } else if(22<val&&val<28){
        return 3
      } else if(27<val&&val<32){
        return 4
      } else {
        return 0
      }
    },
    getLocation (params) {
      let map = window.map
      let BMap = window.baiduMap
      let center = { lng:'', lat:'' }
      let installGps
      if (params) {
        installGps = params.split(',')
      } else {
        installGps = ['116.404','39.915']
      }
      map.clearOverlays()
      center.lng = installGps[0] ? installGps[0] : '116.404'
      center.lat = installGps[1] ? installGps[1] : '39.915'
      let point = new BMap.Point(center.lng, center.lat);
      // map.panTo(point)
      let gc = new BMap.Geocoder();
      let that = this
      gc.getLocation(point, res => {
        // console.log(res);
        // console.log(res.address);
        that.addressNew = res.address
        // return res.address
      })
      // console.log(that.addressNew);
      return that.addressNew
    },
  }
}
</script>

<style lang="scss" scoped>
.cardContainer {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  position: relative;
  box-shadow: 0px 0px 30px 0px rgba(220, 236, 248, 0.69);
  border-radius: 2px;
  background: #fff;
  position: relative;

  &.active {
    border-top: 3px #B8BABC solid;

    .text {
      .titleMess{
        h4 {
          color: #999B9E;
        }
        .ssidMess{
          .common{
            background: #D6D7D8;
          }
        }
        &.act0{
          .ssidMess{
            .mess0{
              background: #999B9E;
            }
          }
        }
        &.act1{
          .ssidMess{
            .mess0{
              background: #999B9E;
            }
            .mess1{
              background: #999B9E;
            }
          }
        }
        &.act2{
          .ssidMess{
            .mess0{
              background: #999B9E;
            }
            .mess1{
              background: #999B9E;
            }
            .mess2{
              background: #999B9E;
            }
          }
        }
        &.act3{
          .ssidMess{
            .common{
              background: #999B9E;
            }
            .mess4{
              background: #D6D7D8;
            }
          }
        }
        &.act4{
          .ssidMess{
            .common{
              background: #999B9E;
            }
          }
        }
      }
    }

    .infoList {
      dl {
        dd {
          &:nth-child(2) {
            width: 100% !important;
          }

          &:nth-child(3) {
            display: none;
          }

          width: 100%;

          .messOther {
            color: #B8BABC;
          }
        }
      }
    }
  }

  &.active1 {
    border-top: 3px #F43300 solid;

    .text {
      .titleMess{
        h4 {
          color: #F43300;
        }
        .ssidMess{
          .common{
            background: #FBC1B2;
          }
        }
        &.act0{
          .ssidMess{
            .mess0{
              background: #F43300;
            }
          }
        }
        &.act1{
          .ssidMess{
            .mess0{
              background: #F43300;
            }
            .mess1{
              background: #F43300;
            }
          }
        }
        &.act2{
          .ssidMess{
            .mess0{
              background: #F43300;
            }
            .mess1{
              background: #F43300;
            }
            .mess2{
              background: #F43300;
            }
          }
        }
        &.act3{
          .ssidMess{
            .common{
              background: #F43300;
            }
            .mess4{
              background: #FBC1B2;
            }
          }
        }
        &.act4{
          .ssidMess{
            .common{
              background: #F43300;
            }
          }
        }
      }
    }

    .infoList {
      dl {
        dd {
          .messOther {
            color: #F76640;
          }
        }
      }
    }
  }

  &.active2 {
    border-top: 3px #08BB80 solid;
    .text {
      .titleMess{
        .ssidMess{
          .common{
            background: #B4EAD8;
          }
        }
        &.act0{
          .ssidMess{
            .mess0{
              background: #08BB80;
            }
          }
        }
        &.act1{
          .ssidMess{
            .mess0{
              background: #08BB80;
            }
            .mess1{
              background: #08BB80;
            }
          }
        }
        &.act2{
          .ssidMess{
            .mess0{
              background: #08BB80;
            }
            .mess1{
              background: #08BB80;
            }
            .mess2{
              background: #08BB80;
            }
          }
        }
        &.act3{
          .ssidMess{
            .common{
              background: #08BB80;
            }
            .mess4{
              background: #B4EAD8;
            }
          }
        }
        &.act4{
          .ssidMess{
            .common{
              background: #08BB80;
            }
          }
        }
      }
    }
  }

  .img {
    position: absolute;
    top: 25px;
    left: 20px;
    width: 150px;
    height: 150px;
  }

  .text {
    width: 100%;
    padding: 14px 14px 0 14px;
    box-sizing: border-box;
    .titleMess {
      overflow: hidden;
      position: relative;
      h4 {
        float: left;
        width: 230px;
        height: 24px;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.85);
        font-size: 18px;
        line-height: 24px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
        font-family: "AlibabaPuHuiTi-Bold";
      }
      .ssidMess {
        width: 30px;
        float: right;
        .common {
          position: absolute;
          width: 3px;
          background: #D6D7D8;
          bottom: 4px;
        }
        .mess0{
          height: 4px;
          margin-left: 0;
          right: 24px;
        }
        .mess1{
          height: 7px;
          right: 18px;
        }
        .mess2{
          height: 10px;
          right: 12px;
        }
        .mess3{
          height: 13px;
          right: 6px;
        }
        .mess4{
          height: 16px;
          right: 0;
        }
      }
    }

    .infoList {
      // height: 75px;
      margin: 10px 0;
      font-size: 0;
      font-family: AlibabaPuHuiTi-Medium;

      dl {
        overflow: hidden;

        dd {
          float: left;
          width: 100%;
          font-size: 14px;
          height: 26px;
          line-height: 26px;
          color: rgba(0, 0, 0, 0.5);
          letter-spacing: 1px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          .messOther {}

          .mess {
            display: inline-block;
            width: 80px;
            height: 26px;
            border-radius: 13px;
            text-align: center;
            overflow: hidden;

            i {
              float: left;
              width: 6px;
              height: 6px;
              border-radius: 50%;
              margin: 10px 10px 0 10px;
            }

            span {
              float: left;
            }
          }

          &:nth-child(3) {
            width: 50%;

            .messAlarm {
              &.normal {
                background: #E6F8F2;
                color: #08BB80;

                i {
                  background: #08BB80;
                }
              }

              &.abnormal {
                background: #FDEAE5;
                color: #F43300;

                i {
                  background: #F43300;
                }
              }
            }
          }

          &:nth-child(2) {
            width: 50%;

            .messOnline {
              &.normal {
                background: #E7F3FF;
                color: #1089FF;

                i {
                  background: #1089FF;
                }
              }

              &.abnormal {
                background: #EEEFEF;
                color: #999B9E;

                i {
                  background: #999B9E;
                }
              }
            }
          }

          &:nth-child(5) {
            font-family: AlibabaPuHuiTi-Regular;
          }
        }
      }
    }
  }

  .handleBtns {
    position: absolute;
    width: 100%;
    box-sizing: border-box;
    padding: 4px;
    left: 0;
    bottom: 0;
    z-index: 1;
    .gotoChild {
      width: 100%;
      overflow: hidden;
      border-radius: 2px;
      height: 36px;
      padding: 0 10px;
      box-sizing: border-box;

      &.activeGray {
        background: #EEEFEF;

        .tip {
          color: #999B9E;
        }
      }

      &.activeGreen {
        background: #E6F8F2;

        .tip {
          color: #08BB80;
        }
      }

      &.activeRed {
        background: #FDEAE5;

        .tip {
          color: #F43300;
        }
      }

      .tip {
        float: left;
        font-size: 14px;
        font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
        font-weight: 500;
        line-height: 36px;
        b {
          font-weight: 500;
        }
      }

      .imgBox {
        width: 36px;
        height: 36px;
        float: right;
        cursor: pointer;
        text-align: right;
        img {
          margin-top: 10px;
          width: 16px;
          height: 16px;
          vertical-align: unset;
        }
      }
    }
  }
}
</style>
